import React from 'react';
import { BookOpenIcon, GiftIcon, StarIcon, UsersIcon } from 'lucide-react';
const items = [{
  icon: UsersIcon,
  label: '+1.500 docentes de Seguridad e Higiene'
}, {
  icon: BookOpenIcon,
  label: '9 tomos completos'
}, {
  icon: GiftIcon,
  label: '5 bonos incluidos'
}, {
  icon: StarIcon,
  label: '4.9/5 calificación'
}];
export function SocialProof() {
  return <section className="border-b border-line bg-white py-5" aria-label="Contenido del Megapack" data-id="element-244" data-mp="3bwhseocpog2p">
      <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-x-8 gap-y-3 px-4 text-sm font-semibold text-muted sm:justify-between" data-id="element-245" data-mp="3h7kv0q1yinj">
        {items.map(({
        icon: Icon,
        label
      }) => <span key={label} className="inline-flex items-center gap-2" data-id="element-246" data-mp="3ut9aiugiop56">
            <Icon className="h-5 w-5 text-navy" aria-hidden="true" data-id="element-247" data-mp="3urg3he1zs2wn" /> {label}
          </span>)}
      </div>
    </section>;
}